module.exports = __webpack_public_path__ + "img/sales.51346673.svg";